import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {FlipControls} from './FlipControls';
import {SizeControl} from './SizeControl';
import {RotateControl} from './RotateControl';

export const TransformSection = ({canvas}) => (
  <div className="uyo-control-section">
    <Typography variant="label2" classNames="uyo-control-section-title" color="pebble">
      TRANSFORM
    </Typography>

    <FlipControls canvas={canvas} />

    <SizeControl canvas={canvas} />

    <RotateControl canvas={canvas} />
  </div>
);
